import { render, staticRenderFns } from "./dashboardrepair.vue?vue&type=template&id=6012a9bd&scoped=true&"
import script from "./dashboardrepair.vue?vue&type=script&lang=js&"
export * from "./dashboardrepair.vue?vue&type=script&lang=js&"
import style0 from "./dashboardrepair.vue?vue&type=style&index=0&id=6012a9bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012a9bd",
  null
  
)

export default component.exports